<template>
  <div class="card-container">
    <Row class=" limit-line " type="flex">
      <Col flex="1" class="desc-field table-row-odd">{{ getTranslation('k186') }}
      </Col>
      <Col flex="1" class="table-row-odd">
      <Select :transfer="true" v-model="info.OptSingleProdSpotCntAlarmFunc" class="input-field"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
      </Select>
      </Col>
      <Col flex="1">
      </Col>
      <Col flex="1">
      {{ getTranslation('k197') }}
      </Col>
      <Col flex="1">
      {{ getTranslation('k198') }}
      </Col>
    </Row>
    <Row class="limit-line menu-actions" type="flex">
      <Col flex="1" class="desc-field">{{ getTranslation('k187') }}
      </Col>
      <Col flex="1">
      <Select :transfer="true" v-model="info.OptScheduleProdMfgCntAlarmFunc" class="input-field"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
      </Select>
      </Col>
      <Col flex="1" class="left-program">
      {{ getTranslation('k193') }}
      </Col>
      <Col flex="1">
      <Input type="text" class="input-field" v-model="info.ValGun1SingleProdSpotCnt" disabled></Input>
      </Col>
      <Col flex="1">
      <Button type="info" size="small" icon="md-close" @click.native="clearVal('ValGun1SingleProdSpotCnt')">{{
        getTranslation('k198') }}</Button>
      </Col>
    </Row>
    <Row class="limit-line menu-actions" type="flex">
      <Col flex="1" class="desc-field table-row-odd">{{ getTranslation('k188') }}
      </Col>
      <Col flex="1" class="table-row-odd">
      <Select :transfer="true" v-model="info.OptAfterAlarmStartTimeCunt" class="input-field"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
      </Select>
      </Col>
      <Col flex="1" class="left-program">
      {{ getTranslation('k194') }}
      </Col>
      <Col flex="1">
      <Input type="text" class="input-field" v-model="info.ValGun1ScheduleProdMfgCnt" disabled></Input>
      </Col>
      <Col flex="1">
      <Button type="info" size="small" icon="md-close" @click.native="clearVal('ValGun1ScheduleProdMfgCnt')">{{
        getTranslation('k198') }}</Button>
      </Col>
    </Row>
    <Row class="limit-line menu-actions" type="flex">
      <Col flex="1" class="desc-field">{{ getTranslation('k189') }}
      </Col>
      <Col flex="1">
      <Select :transfer="true" v-model="info.OptGun1SingleProdSpotCtlFunc" class="input-field"
        :placeholder="getTranslation('m034')" :not-found-text="getTranslation('b038')">
        <Option v-for="(item, key) in SwitchList" :value="key" :key="key">{{ item }}</Option>
      </Select>
      </Col>
      <Col flex="1" class="left-program">
      {{ getTranslation('k195') }}
      </Col>
      <Col flex="1">
      <Input type="text" class="input-field" v-model="info.ValGun1TotalProdMfgCnt" disabled></Input>
      </Col>
      <Col flex="1">
      <Button type="info" size="small" icon="md-close" @click.native="clearVal('ValGun1TotalProdMfgCnt')">{{
        getTranslation('k198') }}</Button>
      </Col>
    </Row>
    <Row class="limit-line menu-actions" type="flex">
      <Col flex="1" class="desc-field table-row-odd">{{ getTranslation('k190') }}
      </Col>
      <Col flex="1" class="table-row-odd">
      <Input type="number" class="input-field" v-model="info.ValGun1AdvancedPartCountLow" />
      </Col>
      <Col flex="1" class="left-program">
      {{ getTranslation('k196') }}
      </Col>
      <Col flex="1">
      <Input type="text" class="input-field" v-model="info.ValGun1TotalProdSpotCnt" disabled></Input>
      </Col>
      <Col flex="1">
      <Button type="info" size="small" icon="md-close" @click.native="clearVal('ValGun1TotalProdSpotCnt')">{{
        getTranslation('k198') }}</Button>
      </Col>
    </Row>
    <Row class="limit-line" type="flex">
      <Col flex="1" class="desc-field">{{ getTranslation('k191') }}
      </Col>
      <Col flex="1">
      <Input type="number" class="input-field" v-model="info.ValGun1AdvancedPartCountHight" />
      </Col>
      <Col flex="3">
      </Col>
    </Row>
    <Row class="limit-line " type="flex">
      <Col flex="1" class="desc-field table-row-odd">{{ getTranslation('k192') }}
      </Col>
      <Col flex="1" class="table-row-odd">
      <Input type="number" class="input-field" v-model="info.ValGun1AdvancedWeldFinishTimSet" />
      </Col>
      <Col flex="3">
      </Col>
    </Row>
    <Row class="limit-line" type="flex">
      <Col flex="1" class="desc-field">{{ getTranslation('k217') }}
      </Col>
      <Col flex="1">
      <Input type="number" class="input-field" v-model="info.ValGun1ScheduleProdMfgSet" />
      </Col>
      <Col flex="3">
      </Col>
    </Row>

    <Row class="menu-actions">
      <Col>
      <Button :type="downloadType" size="small"  icon="md-download" @click.native="downloadCountOne()">{{ getTranslation('k023')
      }}</Button>
      </Col>
    </Row>
  </div>
</template>
<script>
import { API_URL } from '@/constants/const';
import axios from 'axios';
import { Row, Col, Button, Select, Option, Input } from "view-design"
import { postJsError } from '@/util/util.js'

import { mapGetters } from 'vuex'
export default {
  name: 'ElectrodeCount', // 组件名称
  components: {
    Row, Col, Button, Select, Option, Input
  },
  props: {
  },
  data() {
    return {
      info: {},
      mac: 0,
      downloadType: 'primary',
    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    SwitchList() {
      return [
        this.getTranslation("k048"),
        this.getTranslation("k049"),
      ]
    },
  },
  watch: {

  },

  created() {
    this.init();
  },
  methods: {
    init() {
      this.mac = this.$route.query.mac
      this.getInfo();
    },
    getInfo() {
      let url = API_URL["productionElectrodeOneInfo"];
      if (!this.mac) {
        this.$Message.error(this.getTranslation('m041'));
        return
      }
      let params = {
        mac: this.mac
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.info = res.data.data;
            //this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    downloadCountOne() {
      let url = API_URL["ProductionCountOneDownload"] + '?mac=' + this.mac
      let params = new FormData();
      this.info && Object.keys(this.info).forEach(key => {
        params.append(key, this.info[key]);
      });
      axios.post(url,
        params
      )
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
            this.downloadType = 'primary'
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    clearVal(val) {
      this.$set(this.info, val, 0)
      this.$Message.warning(this.getTranslation('b192'))
      this.downloadType = 'error'
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css');
/* 针对 disabled Input 组件的样式 */
::v-deep(.ivu-input.ivu-input-disabled),
::v-deep(.ivu-input[disabled]) {
  color: #999 !important;
  background-color: #f8f9fa !important;
  border-color: #ced4da !important;
  opacity: 1 !important;
  -webkit-text-fill-color: #999 !important;
}
</style>